/* eslint-disable-next-line no-unused-vars */
import React from 'react';
import { Box, Typography, Container, Chip } from '@mui/material';
import Grid from '@mui/material/Grid2';

const skillCategories = [
    {
        label: 'DevOps & Cloud',
        color: '#007FFF',
        skills: ['Kubernetes', 'Jenkins', 'GitHub Actions', 'CI/CD', 'AWS', 'Docker']
    },
    {
        label: 'Languages',
        color: '#6a0dad',
        skills: ['Java', 'C++', 'Python', 'JavaScript', 'HTML', 'CSS']
    },
    {
        label: 'Tools & Frameworks',
        color: '#00897b',
        skills: ['ReactJS', 'Git/GitHub/GitLab', 'Jest', 'JUnit', 'Postman', 'Material UI', 'Zenhub', 'ClickUp', 'Code Climate']
    }
];

const Skills = () => {
    return (
        <div id='skills'>
            <Box sx={{ bgcolor: '#ffffff' }}>
                <Container maxWidth="lg" sx={{ py: 8 }}>
                    <Box sx={{ textAlign: 'center', mb: 6 }}>
                        <Typography variant="overline" sx={{ color: '#007FFF', letterSpacing: '0.15em', fontSize: '0.85rem' }}>
                            What I Know
                        </Typography>
                        <Typography variant='h3' fontWeight={700} mt={1}>
                            Skills
                        </Typography>
                        <Typography variant='body1' color='text.secondary' mt={1}>
                            An outline of skills I have learned through school, internships, and personal projects
                        </Typography>
                    </Box>

                    <Grid container spacing={4}>
                        {skillCategories.map((category) => (
                            <Grid size={{ xs: 12, md: 4 }} key={category.label}>
                                <Box sx={{
                                    border: '1px solid rgba(0,0,0,0.08)',
                                    borderRadius: '16px',
                                    p: 3,
                                    height: '100%',
                                    transition: 'box-shadow 0.3s ease, transform 0.3s ease',
                                    '&:hover': {
                                        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                                        transform: 'translateY(-4px)'
                                    }
                                }}>
                                    <Box sx={{
                                        display: 'inline-block',
                                        bgcolor: category.color,
                                        borderRadius: '8px',
                                        px: 1.5, py: 0.5,
                                        mb: 2
                                    }}>
                                        <Typography variant="subtitle2" color="white" fontWeight={700}>
                                            {category.label}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                        {category.skills.map((skill) => (
                                            <Chip
                                                key={skill}
                                                label={skill}
                                                size="small"
                                                sx={{
                                                    bgcolor: `${category.color}15`,
                                                    color: category.color,
                                                    border: `1px solid ${category.color}40`,
                                                    fontWeight: 500,
                                                    '&:hover': {
                                                        bgcolor: `${category.color}25`,
                                                    }
                                                }}
                                            />
                                        ))}
                                    </Box>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
        </div>
    );
};

export default Skills;
